import {
  signalStore,
  withComputed,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { BaseState, withCrudOperations } from '../crud.state';
import { Commune } from '../../models/commune';
import { CommuneService } from '../../services/commune/commune.service';
import { computed, inject } from '@angular/core';
import { ActiveUserStore } from '../user/active-user.state';
import { withBaseConfig } from './commune.base-configs';

export type CommuneState = BaseState<Commune>;

export const initialState: CommuneState = {
  items: {},
  loading: false,
  selectedId: '',
  selection: [],
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'Commune',
  entityLabel: 'Kommune',
  filter: {
    query: '',
    category: [],
    tags: [],
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const CommuneStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<Commune>(CommuneService),
  withBaseConfig(),
  withComputed(store => ({
    allSlugs: computed(() =>
      Object.values(store.items()).map(item => item.slug)
    ),
  })),
  withMethods((store, communeService = inject(CommuneService)) => ({
    setDefaultBookmark(bookmarkId: string, internal: boolean) {
      communeService.setDefaultBookmark(bookmarkId, !internal);
    },
    setConfiguration(configuration: any) {
      communeService.setConfiguration(configuration);
    },
    async findBySlug(slug: string) {
      const commune: Commune = await communeService.getItem(slug);
      return commune;
    },
    async getActiveCommune() {
      return await communeService.getActiveCommune();
    },
  })),
  withHooks({
    onInit(store, activeUserStore = inject(ActiveUserStore)) {
      if (activeUserStore.isSuperAdmin()) {
        store.loadAllItemsByPromise();
      }
    },
    onDestroy() {
      console.log('on destroy');
    },
  })
);
